import { useContext, useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext";
import { calculateWordsFromString } from "../../../utils/Helper";

export const useProdServiceBuild = ({ projectOpts, dropdownOption, setShowRequestPopup, callApi, editData, setEditData }) => {

    const { showInfo, showSuccess, showError } = useContext(ToastContext);
    const [opts, setOpts] = useState({ build_type: [], jenkins_type: [], jenkins_job_type_all: [], jenkins_job_type: [], approver2: [], project_module: [] });
    const [popupFields, setPopupFields] = useState({ project: {}, project_module: [], build_type: {}, jenkins_job_type: [], approver2: {}, reason: "" });
    const [loader, setLoader] = useState(false);
    const [disableStatus, setDisableStatus] = useState({ project: false, project_module: false, build_type: false, jenkins_job_type: false, approver2: false, reason: false });
    const [serviceView,setServiceView] = useState({show:false,data:[]})

    useEffect(() => {
        setOpts((prev) => ({ ...prev, build_type: dropdownOption?.prod_build_types }));
    }, [dropdownOption?.prod_build_types])

    useEffect(() => {
        if (!_.isEmpty(popupFields?.project) && _.isEmpty(editData)) {
            getAutoBuildJenkinsData();
            getProjectModule();
        }
    }, [popupFields?.project])

    useEffect(() => {
        if (!_.isEmpty(editData)) {
            if (!_.isEmpty(projectOpts)) {
                setPopupFields((prev) => ({ ...prev, project: _.findWhere(projectOpts, { project_id: editData?.project_id }) }));
            }

            if (editData?.approve_status?.action_by === "client") {
                setDisableStatus({ project: true, project_module: true, build_type: true, jenkins_job_type: true, approver2: true, reason: true });
            } else if (editData?.approve_status?.stage === "approve1" && editData?.approve_status?.action_by === "requester") {
                setDisableStatus({ project: true, project_module: true, build_type: true, jenkins_job_type: true, approver2: false, reason: true });
            } else {
                setDisableStatus((prev) => ({ ...prev, project: true }));
            }
        }
    }, [projectOpts, editData])

    useEffect(() => {
        if (!_.isEmpty(editData)) {
            const build_type = _.findWhere(opts?.build_type, { build_type_id: editData?.build_type_id });
            setPopupFields((prev) => ({ ...prev, build_type }));
            if (!_.isEmpty(popupFields?.project)) {
                getAutoBuildJenkinsData(null, build_type);
                getProjectModule();
            }
        }
    }, [opts?.build_type, editData, popupFields?.project])

    useEffect(() => {
        if (!_.isEmpty(editData)) {
            const jenkins_job_type = _.filter(opts?.jenkins_job_type, (item) => editData?.job_ids?.split(",")?.includes(item?.job_id?.toString()));
            setPopupFields((prev) => ({ ...prev, jenkins_job_type }));
        }
    }, [opts?.jenkins_job_type])

    const getAutoBuildJenkinsData = async (projFromList, buildType) => {
        try {
            const payload = {
                project_id: projFromList ? projFromList : popupFields?.project?.project_id || 0,
                build_type_id: buildType ? buildType?.build_type_id : popupFields?.build_type?.build_type_id || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("GETAUTOBUILDJENKINSDATA"), payload);
            if (res) {
                const data = res?.body?.data;
                setOpts((prev) => ({ ...prev, jenkins_type: data?.jenkins_type, jenkins_job_type_all: data?.job_name, approver2: data?.approver2_names }));

                let filteredJenkinsOpts = data?.job_name;
                if (buildType?.build_type_key === "flyway" || (!buildType && popupFields?.build_type?.build_type_key === "flyway")) {
                    filteredJenkinsOpts = _.filter(data?.job_name, item => item?.jenkins_job_type_name?.toLowerCase()?.includes("flyway") || item?.jenkins_job_type_name?.toLowerCase()?.includes("sync-dbscript"));
                }
                setOpts((prev) => ({ ...prev, jenkins_job_type: filteredJenkinsOpts }));

                if (!_.isEmpty(popupFields?.jenkins_job_type)) {
                    const filteredJenkins = _.filter(popupFields?.jenkins_job_type, item => _.pluck(filteredJenkinsOpts, "job_id")?.includes(item?.job_id))
                    setPopupFields((prev) => ({ ...prev, jenkins_job_type: filteredJenkins }));
                }

                if (!_.isEmpty(editData)) {
                    const approver2 = _.findWhere(data?.approver2_names, { client_id: editData?.client_user_code });
                    setPopupFields((prev) => ({ ...prev, approver2, reason: editData?.reason }))
                } else {
                    const approver2 = _.findWhere(data?.approver2_names, { client_id: popupFields?.approver2?.client_id }) || {};
                    setPopupFields((prev) => ({ ...prev, approver2 }));
                }
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const handleSubmit = async () => {
        try {
            if (_.isEmpty(popupFields?.project)) {
                showInfo("Info", "Please select a project");
                return;
            } else if (_.isEmpty(popupFields?.build_type)) {
                showInfo("Info", "Please select the build type");
                return;
            } else if (_.isEmpty(popupFields?.jenkins_job_type)) {
                showInfo("Info", "Please select the jenkins job type");
                return;
            } else if (_.isEmpty(popupFields?.approver2)) {
                showInfo("Info", "Please select the approver 2");
                return;
            } else if (calculateWordsFromString(popupFields?.reason) < 5) {
                showInfo("Info", "Please write the reason of atleast 5 words");
                return;
            } else {
                setLoader(true);
                const payload = {
                    "build_request_id": _.isEmpty(editData) ? 0 : editData?.build_request_id,
                    "job_ids": _.pluck(popupFields?.jenkins_job_type, "job_id")?.toString() || "",
                    "approver2_user_code": popupFields?.approver2?.client_id || 0,
                    "build_type_id": popupFields?.build_type?.build_type_id || 0,
                    "reason": popupFields?.reason || "",
                    "project_module_names": _.pluck(popupFields?.project_module, "option_value")?.toString() || ""
                }
                const res = await services.getInvokeRemote("POST", Urls("UPSERTAUTOBUILDREQUEST"), payload);
                if (res) {
                    if (res?.body?.StatusCode === 400 || res?.body?.StatusCode === 204 || res?.body?.StatusCode === 202 || res?.body?.StatusCode === 401 || res?.body?.StatusCode === 500) {
                        showError("Error", res?.body?.errorMessage);
                    } else {
                        showSuccess("Success", res?.body?.message);
                        setEditData({});
                        setShowRequestPopup(false);
                        callApi();
                    }
                    setLoader(false);
                }
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
        }
    }

    const handleBuildTypeChange = (build) => {
        if (!disableStatus?.build_type) {
            setPopupFields((prev) => ({ ...prev, build_type: build }));
            if ((build?.build_type_key === "flyway" || (popupFields?.build_type?.build_type_key === "flyway" && build.build_type_key !== "flyway")) && !_.isEmpty(popupFields?.project)) {
                getAutoBuildJenkinsData(null, build);
            }
        }
    }

    const handleSearchChange = (e) => {
        if (window.__processingPaste) return;

        if (e.nativeEvent?.inputType === 'insertFromPaste' ||
            (e.nativeEvent?.inputType === 'insertText' &&
                e.nativeEvent?.dataTransfer)) {

            window.__processingPaste = true;
            e.preventDefault();

            const pastedText = e.clipboardData?.getData('text') ||
                e.nativeEvent?.data || '';
            const searchTerms = pastedText.split(',').map(term => term.trim().toLowerCase());
            const invalidTerms = searchTerms.filter(term =>
                !opts.jenkins_job_type.some(job => job.job_name?.toLowerCase() === term)
            );

            if (invalidTerms.length > 0) {
                showInfo("Info", `${invalidTerms.join(', ')} is not valid`);
                setPopupFields(prev => ({
                    ...prev,
                    jenkins_job_type: []
                }));
            } else {
                const matchedJobs = searchTerms.map(term =>
                    opts.jenkins_job_type.find(job => job.job_name?.toLowerCase() === term)
                ).filter(Boolean);

                setPopupFields(prev => ({
                    ...prev,
                    jenkins_job_type: matchedJobs
                }));
            }
            setTimeout(() => {
                window.__processingPaste = false;
            }, 100);
        }
    };

    useEffect(() => {
        window.__processingPaste = false;
        return () => { window.__processingPaste = false; };
    }, []);

    const getProjectModule = async () => {
        const payload = {
            "project_ids": popupFields?.project?.project_id ? popupFields?.project?.project_id?.toString() : ""
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTMODULE'), payload);
            if (res) {
                const data = res.body.data.project_module;
                setOpts((prev) => ({ ...prev, project_module: _.sortBy(data, 'option_value') }));

                if (_.isEmpty(editData)) {
                    if (!_.isEmpty(data)) {
                        setPopupFields((prev) => ({ ...prev, project_module: _.filter(popupFields?.project_module, item => _.pluck(data, 'option_id')?.includes(item?.option_id)) }));
                    } else {
                        setPopupFields((prev) => ({ ...prev, project_module: [] }));
                    }
                } else {
                    const modules = _.filter(data, item => editData?.project_module_ids?.split(",")?.includes(item?.option_id?.toString()));
                    setPopupFields((prev) => ({ ...prev, project_module: modules }))
                }
            }
        }
        catch (error) {
            console.error(error, "error");
        }

    }

    return useMemo(() => ({
        popupFields, setPopupFields, loader, handleSubmit, opts, disableStatus, getAutoBuildJenkinsData, handleBuildTypeChange, handleSearchChange,serviceView,setServiceView
    }), [popupFields, setPopupFields, loader, handleSubmit, opts, disableStatus, getAutoBuildJenkinsData, handleBuildTypeChange, handleSearchChange,serviceView,setServiceView])
}